import React from "react";
import Reveal from "./Reveal";

const steps = [
  { no: "01", title: "Initial", body: "Audit and discovery questionnaire to map where you are versus where you want to be." },
  { no: "02", title: "Strategy", body: "Positioning, audience, narrative and content pillars. The spine of everything." },
  { no: "03", title: "Production", body: "High quality content across formats. Filmed, edited, designed and written with intent." },
  { no: "04", title: "Distribution", body: "Posting cadence, platform native formats and algorithm aware reformatting." },
  { no: "05", title: "Growth", body: "Data review, refinement and scale. Doubling down on what compounds." },
  { no: "06", title: "Leadership & Influence", body: "Shaping how you show up beyond content. Thought leadership, partnerships and the rooms you want to be in." },
];

const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-28 lg:py-36 bg-[var(--lt-cream)]/60 border-t border-b border-[var(--lt-line)]"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16 lg:mb-24">
          <div className="col-span-12 lg:col-span-5">
            <Reveal>
              <p className="eyebrow mb-4">/ Process</p>
              <h2
                className="font-display tracking-editorial text-[var(--lt-charcoal)] leading-[1.05]"
                style={{ fontSize: "clamp(2rem, 4vw, 3.4rem)", fontWeight: 600 }}
              >
                Six steps. <em className="italic text-[var(--lt-bark)]">Compounding</em> outcomes.
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-8 lg:gap-10">
          {steps.map((s, i) => (
            <Reveal key={s.no} delay={i * 80} className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-2">
              <div
                data-testid={`process-step-${i}`}
                className="h-full border-t border-[var(--lt-charcoal)] pt-5"
              >
                <div className="flex items-baseline justify-between mb-6">
                  <span className="lt-num text-3xl">{s.no}</span>
                  <span className="text-[10px] tracking-[0.3em] uppercase text-[var(--lt-bark)]/60">
                    Step
                  </span>
                </div>
                <h3
                  className="font-display text-[var(--lt-charcoal)] mb-3"
                  style={{ fontSize: "1.6rem", fontWeight: 600 }}
                >
                  {s.title}
                </h3>
                <p className="text-sm text-[var(--lt-bark)] leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
